import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const AUTH_BASE = process.env.REACT_APP_AUTH_BASE || "";

export const postVerifySecondaryEmail = createAsyncThunk(
  "postVerifySecondaryEmail",
  async (otp: string) => {
    const { data } = await axios.post(
      `${GATEWAY_BASE + AUTH_BASE}/v1/verifySecondaryEmail`,
      { otp }
    );
    return data;
  }
);

const postVerifySecondaryEmailSlice = createSlice({
  name: "postVerifySecondaryEmail",
  initialState: {
    loading: false,
    verifySecondaryEmail: null as any,
    error: false,
    success: false,
  },
  reducers: {
    resetVerifySecondary: (state) => {
      state.loading = false;
      state.verifySecondaryEmail = null;
      state.error = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postVerifySecondaryEmail.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(postVerifySecondaryEmail.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = false;
      state.verifySecondaryEmail = action.payload;
    });
    builder.addCase(postVerifySecondaryEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const { resetVerifySecondary } = postVerifySecondaryEmailSlice.actions;

export default postVerifySecondaryEmailSlice.reducer;
